import { render, staticRenderFns } from "./DashboardViagens.vue?vue&type=template&id=06ed14d6&"
import script from "./DashboardViagens.vue?vue&type=script&lang=js&"
export * from "./DashboardViagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports